import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { CenteredFlexColumn, LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(CenteredFlexColumn)`
    gap: 32px;
`;

export const InnerContainer = styled(CenteredFlexColumn)`
    gap: 24px;
`;

export const TitlesContainer = styled(CenteredFlexColumn)`
    gap: 12px;
`;

export const Title = styled.div`
    ${setFontVariant("h3", colorsPalettes.carbon[500])};
`;

export const SubTitle = styled(LeftFlexRow)`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
    gap: 7px;
`;
